const boostApiConfig = {
  mode: 'production',
  api: {
    filterUrl: 'https://services.mybcapps.com/bc-sf-filter/filter',
    searchUrl: 'https://services.mybcapps.com/bc-sf-filter/search',
    recommendUrl: 'https://services.mybcapps.com/discovery/recommend',
    suggestionUrl: 'https://services.mybcapps.com/bc-sf-filter/search/suggest',
    productsUrl: 'https://services.mybcapps.com/bc-sf-filter/search/products',
    cdn: 'https://boost-cdn-prod.bc-solutions.net',
    analyticsUrl: 'https://lambda.mybcapps.com/e',
  },
  shop: {
    name: 'NY AND COMPANY',
    url: 'https://sg-nyandco.myshopify.com',
    domain: 'sg-nyandco.myshopify.com',
    currency: 'USD',
    money_format: '<span class="money">&#36;{{amount}}</span>',
    money_format_with_currency: '<span class="money">&#36;{{amount}}</span',
  },
  allowedFilters: [],
}
// allowedFilters: ['pf_opt_size', 'pf_opt_color', 'pf_p_price'],


const allowedFilters = boostApiConfig.allowedFilters;

function getOS(userAgent) {
    let osName = 'windows';
    if (userAgent?.indexOf('Mac') != -1 || userAgent?.indexOf('like Mac') != -1) {
        osName = 'ios';
    }
    if (userAgent?.indexOf('Android') != -1) {
        osName = 'android';
    }
    return osName;
}

function detectDeviceType(pUserAgent) {
    const userAgent = pUserAgent ? pUserAgent.toLowerCase() : '';
    if (
        userAgent.match(/mobile|android|iphone|ipad|ipod|blackberry|windows phone/i)
    ) {
        return 'mobile';
    } else if (userAgent.match(/tablet|ipad/i)) {
        return 'tablet';
    } else {
        return 'desktop';
    }
}

const price_query = `
    query getProductsByIds($ids: [ID!]!) {
    nodes(ids: $ids) {
        ... on Product {
        id
        compareAtPriceRange {
            minVariantPrice {
                amount
            }
        }
        priceRange {
            minVariantPrice {
                amount
            }
        }
        }
    }
    }
`;

async function shopifyGraphQL(query, variables = {}) {
    const endpoint = "https://sg-nyandco.myshopify.com/api/2025-01/graphql.json";
    const accessToken = "545791228e0f41f6fdebcc06ee5fc13c";

    const response = await fetch(endpoint, {
    method: "POST",
    headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": accessToken,
    },
    body: JSON.stringify({ query, variables }),
    });

    const result = await response.json();
    return result.data;
}

async function getAutosuggestResults(params) {
  console.log('getAutosuggestResults...');
  const shopifyStoreDomain = params.shopifyStoreDomain || boostApiConfig.shop.domain;
  const limit = params?.limit ? params.limit : 6;
  const page = params?.page;
  let apiUrl =
    boostApiConfig.api.suggestionUrl +
    '?t=' +
    Date.now() +
    '&shop=' +
    shopifyStoreDomain +
    '&q=' +
    params?.q +
    '&page=' +
    (page ? page : 1) +
    '&product_limit=' +
    limit +
    '&collection_limit=5' +
    '&event_type=init&locale=en&zero_options=false&pg=search_page&product_available=true&variant_available=true';
  let headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  };

  apiUrl = apiUrl.replaceAll('"', '%22').replaceAll("'", '%27');
  console.log('getAutosuggestResults encoded apiUrl :: ', apiUrl);
  const searchResult = await fetch(apiUrl, {
    method: 'GET',
    headers,
  });
  // console.log('searchResult :: ', searchResult);
  if (searchResult.ok) {
    const generateProductMap = (products) => {
        const productMap = {};
        products.forEach((p) => {
            const pid = p?.id?.replace('gid://shopify/Product/', '');
            productMap[pid] = p;
        })
        return productMap; 
    }
    const getMinPrice = (sfPrd) => {
        const productComparePriceMin =
			sfPrd?.compareAtPriceRange?.minVariantPrice?.amount;
		const productPriceMin = sfPrd?.priceRange?.minVariantPrice?.amount;
        if (productComparePriceMin && productPriceMin) {
            return Math.min(Number(productComparePriceMin), Number(productPriceMin))
        } else if (productComparePriceMin) {
            return Number(productComparePriceMin)
        } else if (productPriceMin) {
            return Number(productPriceMin)
        }
        return 0;
    }
    const mergeProductProperties = (products, shopifyProducts) => {
        const productMap = generateProductMap(shopifyProducts?.nodes);
        products?.forEach((p) => {
            const sfPrd = productMap[p.id];
            const minPrice = getMinPrice(sfPrd);
            if (minPrice && minPrice > 0) {
                p.price_min = minPrice;
            }
        })
    }

    let boostSearchResultJson = await searchResult.json();
    boostSearchResultJson['page'] = page ? page : 1;
    const total_products = parseInt(
      boostSearchResultJson?.total_product || 0,
    );
    console.log('total_products :: ', total_products);
    if (boostSearchResultJson?.products?.length > 0) {
        const productIds = boostSearchResultJson?.products?.map((prod) => `gid://shopify/Product/${prod.id}`);
        const graphqlProducts = await shopifyGraphQL(price_query, { ids: productIds });
        mergeProductProperties(boostSearchResultJson?.products, graphqlProducts);
        boostSearchResultJson['product_suggestions'] = boostSearchResultJson?.products;
    }
    delete boostSearchResultJson.products;
    boostSearchResultJson['nbPages'] =
      total_products % limit === 0
        ? Math.floor(total_products / limit)
        : Math.floor(total_products / limit) + 1;
    // console.log('boostSearchResultJson :: ', boostSearchResultJson);
    return boostSearchResultJson;
  } else {
    const errorResponse = await searchResult.text();
    console.error('error in getAutosuggestResults searchResult :: ', errorResponse);
  }
  return {};
}

const initialSearchResp = {
    response: null,
    suggestions: null,
    suggestion_results: {},
};

function getCookie(name) {
  const cookieString = document.cookie;
  const cookies = cookieString.split('; '); // Split into individual cookie strings

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const [cookieName, cookieValue] = cookie.split('='); // Split into name and value

    if (cookieName === name) {
      return decodeURIComponent(cookieValue); // Decode the value in case of special characters
    }
  }
  return null; // Return null if the cookie is not found
}

function toSentenceCase(sentence) {
  if (!sentence) {
    return '';
  }
  return sentence
    .toLowerCase()
    .split(' ')
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

function generateSuggestionsHtmlByType(suggestionArr) {
    let suggestionsByType = '';
    if (searchResponse?.suggestions.length > 0) {
	  searchResponse.suggestions.forEach((suggestion, index) => {
		  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/mouse-events-have-key-events, jsx-a11y/no-static-element-interactions
		  let className = activeSuggestion === suggestion ? 'bg-[#efefef]' : '';
          if (index >= 5) {
            className = className + ' display_none md:display_block';
          }
          suggestionArr.push(`<div
			class="${className} suggestion_item cursor-pointer"
			onclick="onSuggestionClick('${suggestion}')"
			onMouseOver="handleQuery('${suggestion}', 'suggestion')"
		  >${suggestion}</div>`);
        }
	  );
    //   return suggestionsByType.join('');
    }
    // return suggestionsByType;
}

function viewAllLinkMobileHtml() {
    if (searchResponse?.reponse?.length > 0) {
        return `<div class="p-4 pt-2 text-center block md:hidden">
            <a class="text-center text-xl" variant="primary">
                <Input
                type="submit"
                class="underline cursor-pointer underline-offset-[2.5px]"
                value="View All"
                />
            </a>
        </div>`;
    } 
    return '';
}

function viewAllLinkDesktopHtml() {
    if (searchResponse?.reponse?.length > 0) {
        return `<div class="p-4 pt-2 text-center hidden md:block">
            <a class="text-center text-xl" variant="primary">
                <Input
                type="submit"
                class="underline cursor-pointer underline-offset-[2.5px]"
                value="View All"
                />
            </a>
        </div>`;
    }
    return '';
}

function generateProductHtml(product, index) {
    const productUrl = `/products/${product.handle}`;
    return `<a href="${productUrl}"
        title="${product.title}"
        key="${productUrl}"
        class="group relative w-full overflow-hidden p-2 px-2 sm:px-3 lg:px-4 border-black"
        >
        <img
            src="${product?.images_info?.[0]?.src}"
            height="100%"
            width="100%"
            alt="${product.title}"
        />

        <div class="mt-4">
        <p class="font-medium leading-tight text-ellipsis overflow-hidden text-sm mb-[2px] md:max-w-[20vw] xs:max-w-full whitespace-nowrap">
            ${product.title}
        </p>
        <p class="body-small-light leading-tight text-sm">
            $${product.price_min}
        </p>
        </div>
    </a>`;
}
function generateSuggestedProductsHtml() {
    const productsArr = [];
    // productsArr.push(viewAllLinkMobileHtml());
    const productHtmlArr = searchResponse?.response?.slice(0, 4).map((product, index) => {
        return generateProductHtml(product, index);
    });
    if (productHtmlArr?.length) {
        productsArr.push(`<div id="view_all_link">View All</div>`);
        productsArr.push('<div style="display: grid;" class="product-suggestions bg-[#FCFCF5]">');
        productsArr.push(productHtmlArr.join(''));
        productsArr.push('</div>');
    }
    // productsArr.push(viewAllLinkDesktopHtml());
    return productsArr.join('');    
}

function generateSuggestionsHtml() {
    const suggestionArr = [];
    generateSuggestionsHtmlByType(suggestionArr);
    
    // const viewAllLinkMobile = viewAllLinkMobileHtml();
    const suggestionsHtml = suggestionArr.join('');
    return `<div
        style="padding: 0 0 10px; font-weight: 600; font-size: 16px"
        >
        Suggestions
        </div>
        ${suggestionsHtml}`;
}

async function getAutosuggestResult(searchTerm, type) {
    const boostAPIParams = {
        q: searchTerm,
        limit: 6,
        type: 'autosuggest',
    };

    const boostResult = await getAutosuggestResults(boostAPIParams);
    if (type !== 'main') {
        const products = boostResult?.products?.map((hit) => {
            if (hit?.relevantDocument === 'variant') {
                const v_images = hit?.variants?.[0]?.v_images?.filter(
                (v_img) => !v_img?.includes('_sw'),
                );
                if (v_images && v_images.length > 0) {
                hit.imageUrl = v_images.toReversed();
                }
            }
            return hit;
        });
    }
  return boostResult;
}

let searchKeyword;
let activeSuggestion;
let searchResponse = initialSearchResp;
function showSearchInput() {
    const searchQueryInput = document.querySelector('#searchQuery');
    const headerColumnsEl = document.querySelector('#header-group');
    headerColumnsEl.classList.add('search-opened');
    // searchQueryInput.classList.add('active');
    const searchCloseButton = document.querySelector('.close-icon-container .closeButton');
    searchCloseButton.addEventListener('click', (e) => {
        searchQueryInput.querySelector('input').value = '';
        // searchQueryInput.classList.add('hidden');
        const headerColumns = document.querySelectorAll('.header__column');
        headerColumnsEl.classList.remove('search-opened');
        handleQuery('', 'main');
    })
}
document.addEventListener("DOMContentLoaded", () => {
    const searchQueryInput = document.querySelector('#searchQuery input');
    searchQueryInput.addEventListener('input', (event) => {
        console.log('searchQueryInput clicked', event.target.value);
        handleQuery(event.target.value, 'main');
    });
    const searchForm = document.querySelector('#searchQuery #search_form');
    searchForm.addEventListener('submit', (event) => {
        event.preventDefault();
        onSubmit(event, 'main');
    });
    const searchBtn = document.querySelector('#searchQuery #searchBtn');
    searchBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (searchKeyword && searchKeyword.trim()) {
            searchForm.submit();
        }
    });    
});
async function handleQuery(query, type) {
    searchType = type;
    if (type === 'main') {
        searchKeyword = query;
        activeSuggestion = '';
    } else {
        activeSuggestion = query;
        const suggestionItems = document.querySelectorAll('.suggestion_item');
        if (suggestionItems && suggestionItems.length) {
            suggestionItems.forEach(el => {
                const suggestionStr = el.innerHTML?.trim();
                if (activeSuggestion === suggestionStr) {
                    el.classList.add('active');
                } else {
                    el.classList.remove('active');
                }
            })
        }
    }
    if (query && query.trim().length >= 3) {
        const encodedQuery = encodeURIComponent(query);
        let searchSuggestions = searchResponse.suggestions;
        let responseJson = null;
        if (encodedQuery in searchResponse?.suggestion_results) {
            responseJson = searchResponse?.suggestion_results?.[encodedQuery];
        } else {
            const autosuggestResults = await getAutosuggestResult(query, type);
            if (type === 'main') {
                responseJson = autosuggestResults?.product_suggestions;
                searchSuggestions = autosuggestResults?.suggestions || [];
                // searchSuggestions = [];
                const collections = autosuggestResults?.collections;
                if (collections) {
                    for (const coll of collections) {
                    //collections.forEach((coll) => {
                        const sugg = toSentenceCase(coll.title);
                        if (!searchSuggestions?.includes(sugg)) {
                            searchSuggestions.push(sugg);
                        }
                        if (searchSuggestions?.length >= 8) {
                            break;
                        }
                    //});
                    }
                }
            } else {
                responseJson = autosuggestResults?.product_suggestions;
            }
        }

        let suggestion_products = searchResponse.suggestion_results;
        if (
            type !== 'main' &&
            !suggestion_products.hasOwnProperty(encodedQuery)
        ) {
            suggestion_products[encodedQuery] = responseJson;
        }
        searchResponse = {
            response: responseJson,
            suggestions: searchSuggestions,
            suggestion_results: {...suggestion_products},
        };
    } else if (type === 'main') {
        // searchResponse = {
        //     ...initialSearchResp,
        //     suggestion_results: searchResponse.suggestion_results,
        // };
        searchResponse = initialSearchResp;
    }
    const autosuggestResultContainer = document.getElementById("autosuggest_result");
    const suggestionProductsContainer = document.getElementById("suggestion_products_container");
    if (searchResponse?.response?.length || searchResponse?.suggestions?.length) {
        if (type === 'main') {
            const suggestionContainer = document.getElementById("suggestion_container");
            const suggestionHtml = generateSuggestionsHtml();
            suggestionContainer.innerHTML = suggestionHtml;
            suggestionContainer.querySelectorAll('.suggestion_item').forEach(item => {
                const autosuggest = item.dataset.unxassugg;
                if (autosuggest) {
                    item.addEventListener('mouseover', () => {
                        suggestionContainer.querySelectorAll('.suggestion_item').forEach(itm => itm.classList.remove('text-[#A9A9A9]'));
                        item.classList.add('text-[#A9A9A9]');
                    });
                }
            });
        }

        const productsHtml = generateSuggestedProductsHtml();
        suggestionProductsContainer.innerHTML = productsHtml;
        autosuggestResultContainer.classList.remove("hidden");
        document.body.style.overflow = 'hidden';
        const viewAllLink = document.getElementById("view_all_link");
        viewAllLink.addEventListener("click", () => {
            window.location.href = `/search?q=${encodeURIComponent(activeSuggestion || searchKeyword)}`
        });        
    } else {
        document.body.style.overflow = '';
        autosuggestResultContainer.classList.add("hidden");
    }
}

async function onSuggestionClick(suggestion) {
    window.location.href = `/search?q=${encodeURIComponent(suggestion)}`;
};

const onSubmit = (event) => {
    event.preventDefault();
    if (searchKeyword && searchKeyword.length) {
        window.location.href = `/search?q=${encodeURIComponent(searchKeyword)}`;
    }
};

console.log('searchResponse', searchResponse);